import { SagaIterator } from "redux-saga";
import { call, put, takeEvery } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading, setDeleteTraineeTaskError } from "../../repository/slice";
import i18next from "i18next";
import toast from "react-hot-toast";
import { tokens } from "../../../../locales/tokens";
import { getTraineePositionById } from "../getTraineePositionById/action";

function* deleteTraineeTaskWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.delete, '/api/dynamic-destination/intern', payload.body);
        if (isError) {
            yield put(setDeleteTraineeTaskError(message));
        } else {
            yield put(setDeleteTraineeTaskError(null));
            yield put(getTraineePositionById({ id: payload.body.id }))
            toast.success(i18next.t(tokens.course.message.taskRemoved));
        }
    } catch (error) {
        console.error("deleteTraineeTaskWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* deleteTraineeTaskWatcher() {
    yield takeEvery("@saga/DELETE_TRAINEE_TASK", deleteTraineeTaskWorker);
};
